export type ButtonType = {
  value: string
  name: string
}

export enum ContentItemType {
  COLOR,
  RECALL,
  SERVICE,
  WARRANTYEXTENSION,
}
